// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__LYnWc","footer":"ModalCreateQualiphyProcedure_footer__1gCdS","additionData":"ModalCreateQualiphyProcedure_additionData__lu7BX"};